export default __webpack_public_path__ + "static/media/women.1f966e74.svg";